import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from 'Pods/Shared/Icon/Icon'

import EditorForm from './Components/EditorForm'

function BatchDraftEditorModal(props) {
  return (
    <Modal
      isOpen={props.modalIsOpen}
      shouldCloseOnOverlayClick
      onRequestClose={props.closeModal}
      contentLabel="Modal"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open overlay-modal-container--large-closable',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div className="overlay-modal overlay-modal--details-content overlay-modal--batch-draft-editor">
        <button className="btn btn-transparent overlay-modal--close-inner" onClick={props.closeModal}>
          <Icon type={['fal', 'times']} color="grey-dark" />
        </button>

        <div className="content-wrapper">
          <div className="header-text">
            <div className="section__title">Batch Draft Editor</div>
            <p className="text-default">
              Fill in the template below and apply it to all selected drafts. You can save templates for later use.
              <br />
              <span className="text-semibold">Note:</span> details on this page will override the corresponding fields of your assets.
              For example, tags in a template will override any tags in the selected drafts. Empty fields in a template have no effect on the drafts.
            </p>
          </div>

          <EditorForm
            closeModal={props.closeModal}
            itemIds={props.itemIds}
            clearSelection={props.clearSelection}
          />
        </div>
      </div>
    </Modal>
  )
}

BatchDraftEditorModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  itemIds: PropTypes.array.isRequired,
  clearSelection: PropTypes.func.isRequired,
}

export default BatchDraftEditorModal
